import React, { type ReactNode } from "react"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"

interface AdminListCardProps {
  title: string
  subtitle?: string
  badge?: string
  badgeClass?: string
  cardClass?: string
  children: ReactNode
}

interface AdminListMetricItemProps {
  label: string
  value: ReactNode
  accent?: string
}

export const AdminListCard: React.FC<AdminListCardProps> = ({
  title,
  subtitle,
  badge,
  badgeClass = "bg-slate-100 text-slate-700",
  cardClass = "rounded-xl border-2 border-orange-200 bg-orange-50/40 p-3",
  children,
}) => (
  <Animate type={AnimationTypes.fadeInTraslate} duration="0.45s">
    <div
      className={`group shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-md motion-reduce:transform-none motion-reduce:transition-none ${cardClass}`}
    >
      <div className="flex flex-col gap-3">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="break-words text-base font-black text-slate-900">{title}</p>

            {subtitle && <p className="mt-1 break-words text-xs font-semibold text-slate-500">{subtitle}</p>}
          </div>

          {badge && (
            <span className={`rounded-full px-2.5 py-1 text-[11px] font-black uppercase ${badgeClass}`}>{badge}</span>
          )}
        </div>

        {children}
      </div>
    </div>
  </Animate>
)

export const AdminListMetricItem: React.FC<AdminListMetricItemProps> = ({
  label,
  value,
  accent = "text-slate-800",
}) => (
  <div className="rounded-lg border border-slate-100 bg-white px-3 py-2 transition duration-200 hover:border-orange-100 hover:bg-orange-50/40 motion-reduce:transition-none">
    <p className="text-[10px] font-black uppercase tracking-wide text-slate-500">{label}</p>

    <p className={`mt-1 break-words text-sm font-bold ${accent}`}>{value}</p>
  </div>
)
